














import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import IconArrow from '@/components/icons/Arrow.vue';

import { formatMinutesToTime } from '@/utils/date'

const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;
const MINUTES_IN_DAY = MINUTES_IN_HOUR * HOURS_IN_DAY;

@Component({
    components: {
        IconArrow,
    },
})
export default class StepInput extends Vue {
    @Model('update:time', {}) time!: number
    @Prop({ default: 15 }) readonly step!: number
    @Prop({ default: 0 }) readonly min!: number
    @Prop({ default: MINUTES_IN_DAY }) readonly max!: number

    get formattedTime() {
        return formatMinutesToTime(this.time);
    }
    
    updateValue(value: number) {
        this.$emit('update:time', value);
    }

    increase() {
        const value = Math.min(this.time + this.step, this.max);

        this.updateValue(value);
    }

    decrease() {
        const value = Math.max(this.time - this.step, this.min);

        this.updateValue(value);
    }
}
